<template>
  <div :class="['base-card-info', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      联系人信息
    </div>
    <div class="custom-base-info">
      <div class="item">
        <div class="label">
          管理员手机号
        </div>
        <div class="value">
          {{ baseInfo.companyContacts?.loginPhone }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          业务联系人电话
        </div>
        <div class="value">
          {{ baseInfo.companyContacts?.contactPhone }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          单位省份城市
        </div>
        <div class="value">
          {{ baseInfo.companyContacts?.regionName }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          微信号
        </div>
        <div class="value">
          {{ baseInfo.companyContacts?.weChatNo }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          业务联系人姓名
        </div>
        <div class="value">
          {{ baseInfo.companyContacts?.contactName }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          业务对接邮箱
        </div>
        <div class="value">
          {{ baseInfo.companyContacts?.contactEmail }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          经营地址
        </div>
        <div class="value">
          {{ baseInfo.companyContacts?.contactAddress }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          实名状态
          <el-tooltip
            class="auth-tooltip"
            effect="light"
            content="注：实名认证默认开启，开启后企业登录系统需要强制认证"
            placement="right"
          >
            <svg-icon class="w-4 h-4" icon="mingcute:information-line" />
          </el-tooltip>
        </div>
        <div class="value">
          {{ authTypeLabel[baseInfo.companyContacts?.isAuth] }}
        </div>
      </div>
      <div class="item" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { authTypeLabel, ICompanyMergeInfo } from '@core/main/types';
import { inject } from 'vue';
import { SvgIcon } from '@vue3/components';

defineOptions({ name: 'BaseInfo' }); // 账户中心 - 企业基本信息

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});

const baseInfo = inject('baseInfo') as ICompanyMergeInfo;
</script>

<style lang="scss" scoped>
.label {
  @apply flex items-center gap-x-[8px];

  :deep(.svg-icon) {
    @apply w-[14px] h-[14px] cursor-pointer;
  }
}
</style>